import { render, staticRenderFns } from "./KanbanPedidos.vue?vue&type=template&id=2c27e350&scoped=true"
import script from "./KanbanPedidos.vue?vue&type=script&lang=js"
export * from "./KanbanPedidos.vue?vue&type=script&lang=js"
import style0 from "./KanbanPedidos.vue?vue&type=style&index=0&id=2c27e350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27e350",
  null
  
)

export default component.exports